import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { examUpdate } from '../../../../redux/actions/exam/examActions'

function ExamSingleNote(props) {
  const { wrapperClasses, noteType, notes_attributes, examId, saving, isOverview,tonometryNote } = props
  const noteAttr = notes_attributes?.find(item => item.note_type == noteType)
  const [commentText, setCommentText] = useState(noteAttr?.note ?? '')
  const dispatch = useDispatch()

  const handleSubmitExamNote = async () => {
    const updatedNote = noteAttr?.id ? { ...noteAttr, note: commentText } : { note_type: noteType, note: commentText }
    const otherNotes = notes_attributes.filter(item => item.note_type !== noteType)
    await dispatch(examUpdate({ id: examId, notes_attributes: [updatedNote, ...otherNotes] }, { include: '*' }))
  }

  return (
    <>
      {isOverview ?
        <>
          {commentText ? <div className='col-12 d-flex'>
            <label className='mb-0 font-weight-500'>NOTES: </label>
            <p className='ml-2 mb-0'>{commentText}</p>
          </div> : ''}
        </> :
        <div className={`${wrapperClasses}`}>
          <label>{tonometryNote ? 'Note' : 'Additional Comment'}</label>
          <textarea
            rows={1}
            value={commentText}
            disabled={saving}
            className={`form-control font-size-16 ${saving ? 'disabled' : ''}`}
            onBlur={() => handleSubmitExamNote()}
            onChange={(e) => setCommentText(e.target.value)}
          />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state) => {
  const { exam: { exam, saving } } = state
  return {
    saving,
    examId: exam.id,
    notes_attributes: exam.notes_attributes || []
  }
}

export default connect(mapStateToProps)(ExamSingleNote)